import React from 'react';
import VstComponent from './VstComponent';

class VstLilHeadFooter extends VstComponent {

  render() {
    return (
      <div className="vst-lil-head-footer">
        {this.props.children}
      </div>
    );
  }

}

export default VstLilHeadFooter;
